import { render } from "./SolicitarPaciente.vue?vue&type=template&id=3f9bb7ea&scoped=true"
import script from "./SolicitarPaciente.vue?vue&type=script&lang=js"
export * from "./SolicitarPaciente.vue?vue&type=script&lang=js"

import "./SolicitarPaciente.vue?vue&type=style&index=0&id=3f9bb7ea&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f9bb7ea"]])

export default __exports__